class LaborCostSettings {
  constructor(Restangular, LaborUISchema, $rootScope) {
    'ngInject';

    Object.assign(this, { Restangular, LaborUISchema, $rootScope });

    this._promise = null;
    this.noAccess = true;
    this.settings = null;
    this.savedSettings = null;

    $rootScope.$on('socket:org:edit', () => {
      // LCA settings might have changed
      this._promise = null;
    });
  }

  async loadData() {
    if (!this._promise) {
      this._promise = this._loadFromServer();
    }

    try {
      return await this._resolveSettings();
    } catch (error) {
      this._promise = null;

      if (error.status === 405) {
        this.noAccess = true;
      }
      throw error;
    }
  }

  _loadFromServer() {
    return this.Restangular.one('labor/settings').get();
  }

  async _resolveSettings() {
    this.savedSettings = null;
    this.settings = null;

    const data = await this._promise;
    this.noAccess = false;
    this.savedSettings = data;
    this.settings = this.Restangular.copy(data);

    return this.settings;
  }

  async save(settings = this.settings) {
    const calculatorTypeChanged =
      this.savedSettings.laborCostCalculatorType !== settings.laborCostCalculatorType;

    this._promise = this.Restangular.one('labor/settings').customPUT(settings);
    this.savedSettings = await this._promise;

    if (calculatorTypeChanged) {
      this.LaborUISchema.clearCache();
      await this.LaborUISchema.getSchema();
    }
  }

  reset() {
    if (this.savedSettings) {
      this.settings = this.Restangular.copy(this.savedSettings);
    } else {
      this.settings = null;
    }
  }
}

export default LaborCostSettings;
